import InspectedListPage from './InspectedListPage-compose';

export default InspectedListPage;
